<template>
  <page-listado :fluid="true">
    <page-header title="Descuentos">
      <b-button variant="primary" size="sm" to="/descuentos/crear">
        <v-icon name="plus" width="16" />
        Crear descuento
      </b-button>
    </page-header>
    <tabla :descuentos="descuentos" @eliminar="eliminar" />
  </page-listado>
</template>

<script>
import * as tipoDescuentoApi from "@/services/tipoDescuento.js";
import Tabla from "./TablaTiposDescuentos.vue";

export default {
  components: { Tabla },
  data() {
    return {
      descuentos: [],
    };
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.listar();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.listar();
  },
  methods: {
    async listar() {
      this.descuentos = await tipoDescuentoApi.listar(this.$route.query);
    },
    async eliminar(id) {
      await tipoDescuentoApi.eliminar(id);
      this.listar();
    },
  },
};
</script>
